import { routerPaths } from "./Paths";

const constants = {
  pricePerCall: 100,
  ticketReloadReqTime: 60,
  receiptUrl: {
    wallet:
      process.env.NODE_ENV == "production"
        ? "http://panel.dev.limootel.com/wallet"
        : "http://localost:3000/wallet",
    broadcast: (id: number) =>
      process.env.NODE_ENV == "production"
        ? `http://panel.dev.limootel.com/${routerPaths.VOICE_BROADCASTS}/${id}/paying`
        : `http://localost:3000/${routerPaths.VOICE_BROADCASTS}/${id}/paying`,
  },
};

export default constants;
